import { leadsTasksListOptions, ReturnLeadReadable } from '@crm/api'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { SkeletonWrapper, Text } from '@shared/components'
import { useQuery } from '@tanstack/react-query'
import { Button, Flex } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { LeadTaskItem } from './LeadTaskItem'

type Props = {
  lead: ReturnLeadReadable
}

export const LeadTasks = ({ lead }: Props) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useAppNavigate()

  const { data, isLoading } = useQuery({
    ...leadsTasksListOptions({
      path: {
        lead_id: String(id)
      },
      query: {
        per_page: 3
      }
    }),
    enabled: !!id
  })

  return (
    <Flex vertical gap={8}>
      <Flex justify="space-between" align="center">
        <Text weight={600}>{t('lead.tasks')}</Text>

        <Button
          color="primary"
          variant="link"
          onClick={() => navigate(`${paths.leads}/${lead?.id}/tasks`)}
        >
          {t('reports.view_all')}
        </Button>
      </Flex>

      <SkeletonWrapper loading={isLoading} paragraph={{ rows: 2 }}>
        <Flex vertical gap={8}>
          {data?.results?.map((task) => (
            <LeadTaskItem key={task?.id} task={task} />
          ))}
        </Flex>
      </SkeletonWrapper>
    </Flex>
  )
}
